import React from 'react';
import ReactDOM from 'react-dom/client';

import { PrimeReactProvider } from 'primereact/api';

import { applyBrandToRoot } from '@/shared/config/brand/apply-brand';
import { brand } from '@/shared/config/brand/brand';

import './index.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';

import { renderLoadError } from './render-load-error';
import { resolveEntry } from './resolve-entry';

applyBrandToRoot(document.documentElement, brand);

// O caminho decide o que baixar: `/s/…` (acompanhamento público) carrega só a própria página;
// o resto carrega o painel. O CSS acima é comum às duas entradas.
const entry: Promise<{ default: React.ComponentType }> =
  resolveEntry(window.location.pathname) === 'share' ? import('./share-entry') : import('./_app');

entry
  .then(({ default: Entry }) => {
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <PrimeReactProvider>
          <Entry />
        </PrimeReactProvider>
      </React.StrictMode>,
    );
  })
  .catch(() => {
    renderLoadError(document.getElementById('root')!, () => window.location.reload());
  });
